
import { Component, Mixins } from 'vue-property-decorator';
import { ClientType, ClientReference } from 'ah-api-gateways';
import NotificationSettingsTable from '@/app/components/settings/notifications/NotificationSettingsTable.vue';
import NotificationGroupSettingEditForm from './NotificationGroupSettingEditForm.vue';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';
import { useAuthStore } from '@/app/store/authModule';
import { useNotificationSettingsStore } from '@/app/store/notificationSettingsModule';

@Component({
  components: { NotificationGroupSettingEditForm, NotificationSettingsTable },
})
export default class NotificationSettingsEditor extends Mixins(WithRequestManager) {
  requestManagerConfig = {
    exposeToParent: true,
    onRetryFromParentManager: this.onRetryFromParentManager,
  };

  onRetryFromParentManager(k: string) {
    if (k === 'loadNotifications' || k === 'loadNotificationsConfig') {
      this.created();
    }
  }

  created() {
    this.requestManager.currentOrNewPromise('loadNotificationsConfig', () =>
      this.notificationSettingsStore.loadNotificationConfig(true)
    );
    this.requestManager.currentOrNewPromise('loadNotifications', () =>
      this.notificationSettingsStore.loadNotificationSettings(true)
    );
  }

  get authStore() {
    return useAuthStore();
  }

  get notificationSettingsStore() {
    return useNotificationSettingsStore();
  }

  get notificationSettingConfigs() {
    return this.notificationSettingsStore.notificationConfig?.filter((config) => config.editable);
  }

  get client(): ClientReference | null {
    return this.authStore.loggedInIdentity?.client ?? null;
  }

  get isIndividualClient() {
    return this.authStore.isClientUser && this.client!.type === ClientType.INDIVIDUAL;
  }

  get notifications() {
    return this.notificationSettingsStore.notificationSettings;
  }

  get isStackedView() {
    return this.$mediaQuery.is('smDown');
  }

  get loadingNotifications() {
    return (
      Object.keys(this.notifications.notifications).length === 0 &&
      this.requestManager.requestStates.loadNotifications === 'pending'
    );
  }
}
